export default "__VITE_ASSET__Q2h0YF9N__"